import React from 'react';
import { CheckCircle2, CircleDashed, ShieldCheck, Clock } from 'lucide-react';

const C = { navy: '#0D1B2A', green: '#1D9E75', amber: '#E8A020', slate: '#5C6B7A' };

const ABN_LABEL = {
  abr_confirmed: ['Confirmed on the Australian Business Register', C.green, ShieldCheck],
  checksum_valid_abr_pending: ['Checksum valid · register confirmation pending', C.amber, Clock],
  not_provided: ['Not yet provided', C.slate, CircleDashed],
};

export default function BrokerageProfileStatus({ data }) {
  const comp = data.completeness;
  const [abnText, abnColor, AbnIcon] = ABN_LABEL[data.abn_status] || ABN_LABEL.not_provided;
  const color = comp.complete ? C.green : C.amber;
  return (
    <div className="flex flex-wrap items-center gap-3 text-[11px]" data-testid="brokerage-profile-status">
      <span className="flex items-center gap-1 px-2 py-0.5 rounded-full font-semibold" style={{ background: color + '18', color }} data-testid="brokerage-completeness">
        {comp.complete ? <CheckCircle2 className="w-3 h-3" /> : <CircleDashed className="w-3 h-3" />}
        {comp.complete ? 'Profile complete' : `${comp.filled} of ${comp.required} details on file`}
      </span>
      <span className="flex items-center gap-1" style={{ color: abnColor }} data-testid="brokerage-abn-status" title={data.abn_note || ''}>
        <AbnIcon className="w-3 h-3" /> ABN: {abnText}
      </span>
      {!comp.complete && <span style={{ color: C.slate }} data-testid="brokerage-missing">Missing: {comp.missing.join(', ')}</span>}
      {data.abr?.entity_name && <span style={{ color: C.navy }} data-testid="brokerage-abr-name">Register name: <b>{data.abr.entity_name}</b>{data.abr.status ? ` · ${data.abr.status}` : ''}</span>}
    </div>
  );
}
